import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 265 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 265 512\" id=\"facebook\"><path d=\"M172 512V278.5h78.1l11.7-91H172v-58.1c0-26.4 7.3-44.3 45-44.3h48V3.6C256.7 2.5 228.2 0 195 0 125.7 0 78.3 42.4 78.3 120.3v67.1H0v91h78.3V512H172z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/facebook.svg
// module id = 122
// module chunks = 6